<template>
  <div>
    <wc-page-title title='Controllers'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='All Controllers'
            showAdd
            @add='newItem'
          >
            <v-data-table
              dense
              :items='controllers'
              item-class='no-overflow'
              :headers='headers'
              @click:row='openEdit'
              hide-default-footer
              :items-per-page='-1'
            >
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

<!-- edit/new dialog box below  -->
    <wc-dialog
      :showDialog='showDialog'
      :title='itemCopy.id ? "Edit Controller" : "Add new Controller" '
      icon='mdi-gamepad-circle'
      width='600'
      @cancel='cancelEdit'
      @save='save'
      :loading='isLoading'
      :disableButtons='!isFormValid'
    >
      <v-form ref='form' v-model='isFormValid'>
        <v-row>
          <v-col cols='12'>
            <v-text-field
              ref='description'
              label='Description'
              :rules='[rules.required]'
              v-model='itemCopy.description'
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row> 
          <v-col cols='12'>
            <v-textarea
              outlined
              label='On Instructions'
              :rules='[rules.required]'
              v-model='itemCopy.on_instructions'
            ></v-textarea>
          </v-col>
          <v-col cols='12'>
            <v-textarea
              outlined
              label='Off Instructions'
              :rules='[rules.required]'
              v-model='itemCopy.off_instructions'
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12' sm='4'>
            <v-text-field
              label='Estimate Price'
              :rules='[rules.decimal]'
              v-model='itemCopy.estimate_price'
              append-icon='mdi-currency-usd'
              reverse
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='4'>
            <v-text-field
              label='Service Price'
              :rules='[rules.decimal]'
              v-model='itemCopy.service_price'
              append-icon='mdi-currency-usd'
              reverse
            ></v-text-field>
          </v-col>
          <v-col cols='12' sm='4'>
            <v-text-field
              label='Company Price'
              :rules='[rules.decimal]'
              v-model='itemCopy.company_cost'
              append-icon='mdi-currency-usd'
              reverse
            ></v-text-field>
            <!-- append icon + reverse puts the icon in the prepend-inner position, which imho looks better for left margin alignment of the lines - MJ -->
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import inventoryAPI from '@/modules/assets/api/inventory'
import miscServices from '@/services/misc'
import formRules from '@/mixins/formRules'
import _ from 'lodash'

export default {
  name: 'controllers',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    showDialog: false,
    isFormValid: false,
    itemCopy: {},
    controllers: [],
    headers: [
      { text: 'Description', value: 'description', class:'overline', align: 'start' },
      { text: 'On Instructions', value: 'on_instructions', class:'overline', align: 'start', width: '300' },
      { text: 'Off Instructions', value: 'off_instructions', class:'overline', align: 'start', width: '300' },
    ]
  }),
  computed:{
    irrigationDivision () {
      return _.find(this.$store.state.misc.divisions, ['division', 'Irrigation'])
    },
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      // is there a specific endpoint to get controllers only? I don't see anything in the docs - MJ
      let tmp = await inventoryAPI.getInventoryForDivision(this.irrigationDivision.id)
      console.log(tmp)
      this.controllers = tmp.filter(i => i.is_controller === true)
      this.isLoading = false
    },
    async save() {
      this.isLoading = true
      if (this.itemCopy.id) {
        let tmp = await inventoryAPI.updateInventoryItem(this.itemCopy)
        miscServices.replaceObject(this.controllers, tmp)
      } else {
        this.controllers.push(await inventoryAPI.newInventoryItem(this.itemCopy))
      }
      this.isLoading = false
      this.showDialog = false
    },
    openEdit (item) {
      this.itemCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    newItem () {
      this.itemCopy = {}
      this.itemCopy.is_controller = true
      this.itemCopy.division = this.irrigationDivision.id
      this.showDialog = true
      setTimeout(() => {
        this.$refs.form.resetValidation()
      }, 50)
      setTimeout(() => {
        this.$refs.description.focus()
      }, 100)
    }
  },
  components: {
    
  }
}
</script>